module.exports = __webpack_public_path__ + "yeni h.k. 2.jpg?8c140499a916a47c201b7cc320901d3d";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/yeni h.k. 2.jpg
// module id = 393
// module chunks = 0